import { PRODUCT_NAME_CONSTANTS } from 'vrlcm-gui-constants';
import { l10n } from '../../../i18n/i18nUtil';

export const API_BASE_URL = process.env.REACT_APP_LOCKER_BASE_API_URL;

export const LCOPS = `/lcm/lcops`;

export const NO_BLANK_STRING_REGEX = /^(?!\s*$).+$/;

export const CERTIFICATE_KEYS_MAPPING = {
  period: l10n('appConstants.fieldMapping.period'),
  expiresOn: l10n('appConstants.fieldMapping.expiresOn'),
  issuedOn: l10n('appConstants.fieldMapping.issuedOn'),
  healthy: l10n('appConstants.fieldMapping.healthy'),
  subject: l10n('appConstants.fieldMapping.subject'),
  issuer: l10n('appConstants.fieldMapping.issuer'),
  san: l10n('appConstants.fieldMapping.subjectAlternativeNames'),
  algorithm: l10n('appConstants.fieldMapping.algorithm'),
  keyAlgorithm: l10n('appConstants.fieldMapping.keyAlgorithm'),
  keyLength: l10n('appConstants.fieldMapping.keyLength'),
  sha256: l10n('appConstants.fieldMapping.sha256'),
  sha1: l10n('appConstants.fieldMapping.sha1')
};

export const PASSWORD_DETAIL_KEY_MAPPING = {
  alias: l10n('locker.passwords.passwordList.passwordAlias'),
  password: l10n('password'),
  passwordDescription: l10n('appConstants.fieldMapping.description'),
  userName: l10n('appConstants.fieldMapping.userName'),
  createdOn: l10n('appConstants.fieldMapping.createdOn'),
  lastUpdatedOn: l10n('appConstants.fieldMapping.lastUpdatedOn')
};

export const dynamicRowsCols = (type: string) => {
  let cols: string[] = [],
    rows: string[] = [];
  switch (type) {
    case 'environments':
      cols = ['environment', 'product', 'type', 'user', ''];
      rows = ['envName', 'destinationName', 'type', 'meta.user', ''];
      break;
    case 'vcenter':
      cols = ['dataCenterCaps', 'vCenter', 'user', ''];
      rows = ['envName', 'destinationName', 'meta.user', ''];
      break;
    case 'settings':
      cols = ['setting', 'type', 'user', ''];
      rows = ['envId', 'type', 'meta.user', ''];
      break;
    default:
      cols = [];
      rows = [];
  }
  return { cols, rows };
};

export const PRODUCT_MAPPING = PRODUCT_NAME_CONSTANTS;

export const RESOURCE_ALIAS = /^[^,:]+$/;

export const COMPONENT_MAPPING = {
  'vra-vra': l10n('appConstants.fieldMapping.cafeComponent'),
  'vra-iaas-web': l10n('appConstants.fieldMapping.iaaSWebComponent'),
  'vra-iaas-ms': l10n('appConstants.fieldMapping.iaaSManagerComponent')
};

export const colors = [
  '#9B56BB',
  '#004A70',
  '#FF8400',
  '#89CBDF',
  '#2F8400',
  '#ffdc0B',
  '#C92100',
  '#0079B8',
  '#281336',
  '#485969',
  '#B0105B',
  '#4D007A',
  '#F1428A',
  '#1A23A0',
  '#006668',
  '#00D4B8',
  '#D28F00',
  '#313131',
  '#FF8142',
  '#AADB1E'
];
